// this is an autogenerated file from DesignSystem/DataVaxiomEmployeeProfessionalsRelationshipsItem/Menu/Option/deleteProfessionalRelationshipMutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_DataVaxiomEmployeeProfessionalsRelationshipsItem_Menu_Option($id: numeric!) {
  delete_vaxiom_professional_relationships_by_pk(id: $id) {
    id
  }
}

`